'use client';

import { useEffect, useState } from 'react';

// Совпадает с $ritm-desktop в app/styles/variables.module.scss.
const DESKTOP_MEDIA_QUERY = '(min-width: 1440px)';

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const updateIsDesktop = () => setIsDesktop(mediaQuery.matches);

    updateIsDesktop();
    mediaQuery.addEventListener('change', updateIsDesktop);

    return () => mediaQuery.removeEventListener('change', updateIsDesktop);
  }, []);

  return isDesktop;
};
